<template>
  <div>
    <div class="home">this is the home page</div>
    <Auth />
  </div>
</template>

<script>
import Auth from "../components/Auth";

export default {
  name: "home",
  components: { Auth }
};
</script>
